import {useState, useEffect} from 'react';
import Form from 'react-bootstrap/Form'
import AlertConfirmModal from '../../../common/AlertConfirmModal';
import moment from 'moment'
import Spinner from 'react-bootstrap/Spinner'

const ScheduledPostsCron = () => {
  const [isLoading, setIsLoading] = useState(false)
  const [status, setStatus] = useState(false)
  const [show, setShow] = useState(false)
  const [confirm, setConfirm] = useState(false)
  const [posts, setPosts] = useState([])

  const getScheduledPost = () => {
    setIsLoading(true)
    axios.get(`/api/administration/crons/scheduled-posts`)
      .then(response => {
        setStatus(response.data.status == 3 ? false : true)
        setPosts(response.data.posts)
        setIsLoading(false)
      })
      .catch(error => {
        setIsLoading(false)
      })
  }

  useEffect(() => {
    getScheduledPost()
  }, [])

  const handleChange = (e) => {
    setShow(true)
    setIsLoading(true)
    axios.put('/api/administration/crons/scheduled-posts', {
        status: !status
      })
      .then(response => {
        setIsLoading(false)
        setConfirm(false)
        setShow(false)
      })
      .catch(error => {
        setIsLoading(false)
        setConfirm(false)
        setShow(false)
      })

    setStatus(status => !status)
  }

  const handleConfirm = () => {
    setConfirm(true)
    setShow(false)
  }

  useEffect(() => {
    if (confirm) {
      handleChange()
    }
  }, [confirm])

  return (
    <div>
      <div className="row">
        <div className="col-md-6">
          <div className="text-left">
            Total: {posts.length}
          </div>
        </div>
        <div className="col-md-6">
          <div className="text-right mb-4">
            <span className="mr-2">Cron Status</span> <Form.Check
              inline
              type="switch"
              id="custom-switch"
              title="Cron Status"
              label={status ? 'On' : 'Off'}
              checked={status}
              disabled={isLoading}
              onChange={() => setShow(show => !show)}
            />
          </div>
        </div>
      </div>
      { isLoading && <div className="my-2">
        <Spinner variant="primary" size="sm" animation="border" /> Getting latest data...
      </div>}
      <table className="table table-condensed table-bordered table-sm table-stripe">
        <thead>
          <tr>
            <th>Post Id</th>
            {/* <th>Caption</th> */}
            <th>Author</th>
            <th>Scheduled Date</th>
          </tr>
        </thead>

        <tbody>
          {
            posts.length > 0 && posts.map(post => (
              <tr key={post.id}>
                <td>{post.id}</td>
                {/* <td>{post.caption}</td> */}
                <td>{post.user.login}</td>
                <td>
                  {
                    moment.utc(post.sched_date).local().format('lll')
                  }
                </td>
              </tr>
            ))
          }

          {
            posts.length <= 0 && <tr>
              <td colSpan={4}>No scheduled post</td>
            </tr>
          }
        </tbody>
      </table>

      <AlertConfirmModal
        modalBody={`Are you sure you want to turn ${status ? 'off' : 'on'} the cron?`}
        show={show}
        setShow={setShow}
        isConfirm={true}
        useFunction={handleConfirm}
        busy={isLoading}
      />
    </div>
  )
}

export default ScheduledPostsCron